// Zentrale Wahrheit für "ist echter zahlender Mitglieds-Zugang".
//
// Ersetzt drei zuvor divergierende Implementierungen (Admin-Teilnehmerliste,
// useSubscription-Hook, StudentSettings-TeamTab). Alle Konsumenten rufen
// isRealMember() auf, damit sich Bugs vom Typ "Admin zeigt Mitglied, Team-Tab
// zeigt Nicht-Mitglied" nicht wiederholen können.
//
// Regeln (in dieser Reihenfolge ausgewertet):
//   (a) Paid-Tier + Stripe-Customer- oder Sub-ID → Mitglied
//       (Stripe ist Wahrheit: schlägt tier_source, das durch training-Grant
//       überschrieben sein kann.)
//   (b) tier_source ∈ { stripe, guest, manual } → Mitglied
//   (c) tier_source = training → kein Mitglied
//   (d) Fallback: Paid-Tier ja/nein

export type MembershipTier = string | null | undefined;
export type MembershipTierSource = string | null | undefined;

export interface MembershipInput {
  tier: MembershipTier;
  tierSource: MembershipTierSource;
  stripeCustomerId?: string | null;
  stripeSubscriptionId?: string | null;
}

const PAID_TIERS = new Set(["pro", "fachkraft", "plus"]);

export function isRealMember(input: MembershipInput): boolean {
  const tier = input.tier ?? "start";
  const hasPaidTier = PAID_TIERS.has(tier);
  const source = input.tierSource ?? null;

  // (a) Stripe schlägt tier_source
  if (
    hasPaidTier &&
    (input.stripeCustomerId || input.stripeSubscriptionId)
  ) {
    return true;
  }

  // (b) explizit Nicht-Training-Quelle
  if (source === "stripe" || source === "guest" || source === "manual") {
    return true;
  }

  // (c) Training-Zugang zählt nicht als Mitgliedschaft
  if (source === "training") return false;

  // (d) Fallback
  return hasPaidTier;
}
